import Sidebar from "../../components/sidebar";
import { FiShoppingBag } from "react-icons/fi";
import { useState, useEffect } from "react";
import {
  getAllPackages,
  setCurrentPackage,
  getProfile,
} from "../../services/api";
import Notiflix from "notiflix";
import { useNavigate, useParams } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { motion, AnimatePresence } from "framer-motion";
import { getAstrologers } from "../../services/astrologerService";

export default function ModuleList() {
  const [packages, setPackages] = useState([]);
  const [activeCategory, setActiveCategory] = useState("Bana Özel");
  const [currentPackage, setCurrentPackageState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const [selectedModules, setSelectedModules] = useState({});
  const [astrologers, setAstrologers] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  // Notiflix'i initialize et
  useEffect(() => {
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });
  }, []);

  const fetchAstrologers = async () => {
    try {
      const data = await getAstrologers();
      setAstrologers(data);
    } catch (error) {
      console.error("Astrologer fetch error:", error);
    }
  };

  useEffect(() => {
    if (activeCategory === "Astrologlar") {
      fetchAstrologers();
    }
  }, [activeCategory]);

  // Packages'ları fetch et
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        setLoading(true);
        const response = await getAllPackages();
        if (response && response.packages) {
          setProfileData(response.user);
          // id'si 1 ve 11 olanları gizle, is_active false olanları gizle, sort_order'a göre sırala
          const hiddenById = [1, 11];
          const filteredAndSorted = response.packages
            .filter((pkg) => !hiddenById.includes(pkg.id) && pkg.is_active !== false)
            .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));

          setPackages(filteredAndSorted);
          setCurrentPackageState(response.user?.current_package ?? null);

          // Seçili modülleri initialize et
          const initialSelected = {};
          filteredAndSorted.forEach((pkg) => {
            initialSelected[pkg.package_id] = false;
          });
          setSelectedModules(initialSelected);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);


  // API'den gelen isimleri çevir

  const getModuleName = (name) => {
    const nameMap = {
      "Birth Chart": "Doğum Haritası",
      Numerology: "Numeroloji",
      "Vision Board": "Hayal Panosu",
      Synastry: "Sinastri",
      Affirmation: "Olumlama",
      "Human Design": "Human Design",
    };
    return nameMap[name] || name;
  };

  // Sekme filtresi
  const filteredByCategory = packages.filter((pkg) => {
    return pkg.category_name === activeCategory;
  });

  const moduleCards = filteredByCategory.map((pkg, index) => {
    const heightClasses = [
      "h-[210px]",
      "h-[167px]",
      "h-[224px]",
      "h-[210px]",
      "h-[167px]",
    ];
    // Yüksekliği indeks yerine package_id'ye göre belirle ki filtrelerde de sabit kalsın
    const keyForHeight =
      typeof pkg.package_id === "number" ? pkg.package_id : index;
    const heightClass = heightClasses[keyForHeight % heightClasses.length];

    // Status kontrolü - status 3 ise disable
    const isDisabled = pkg.status === 2;

    return (
      <div
        key={pkg.id}
        className={`rounded-lg relative w-full ${heightClass}`}
      >
        <div className="relative w-full h-full rounded-lg overflow-hidden">
          <img
            src={pkg.image_url || "/assets/pngImages/defaultModule.png"}
            alt={getModuleName(pkg.name)}
            className={`w-full h-full object-cover rounded-lg ${isDisabled
              ? 'grayscale opacity-50 cursor-not-allowed'
              : 'cursor-pointer'
              }`}
            onClick={() => !isDisabled && navigate(`/${id}/${pkg.package_id}`)}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-80 pointer-events-none rounded-lg"></div>

          {/* Bakımda etiketi */}
          {isDisabled && (
            <div className="absolute top-2 right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-medium z-10">
              Bakımda
            </div>
          )}

          <div
            onClick={() => !isDisabled && navigate(`/${id}/${pkg.package_id}`)}
            className={`absolute bottom-0 left-0 right-0 p-4 rounded-b-lg bg-transparent ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
              }`}
          >
            <h3 className={`text-start font-poppins text-[18px] font-bold leading-[30px] ${isDisabled ? 'text-gray-400' : 'text-white'
              }`}>
              {getModuleName(pkg.name)}
            </h3>
          </div>
        </div>
      </div>
    );
  });

  const astrologerCards = astrologers.map((astro, index) => {
    const heightClasses = [
      "h-[210px]",
      "h-[167px]",
      "h-[224px]",
      "h-[210px]",
      "h-[167px]",
    ];
    const heightClass = heightClasses[index % heightClasses.length];

    // Dummy UI Avatars usage as placeholder
    const avatarUrl = `https://ui-avatars.com/api/?name=${astro.name.replace(' ', '+')}&background=3DA7B5&color=fff&size=256&bold=true`;

    return (
      <div
        key={astro.id}
        className={`rounded-lg relative w-full ${heightClass}`}
      >
        <div className="relative w-full h-full rounded-lg overflow-hidden bg-gray-100 cursor-pointer shadow-sm group" onClick={() => {
          navigate(`/${id}/astrologer/${astro.id}`);
        }}>
          <img
            src={astro.avatar || avatarUrl}
            alt={astro.name}
            className="w-full h-full object-cover rounded-lg group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent pointer-events-none rounded-lg"></div>

          <div className="absolute bottom-0 left-0 right-0 p-4 rounded-b-lg bg-transparent text-left">
            <h3 className="font-poppins text-[18px] font-bold leading-tight text-white mb-1">
              {astro.name}
            </h3>
            <p className="text-xs text-[#3DA7B5] font-bold tracking-wider uppercase">
              {astro.archetype}
            </p>
          </div>
        </div>
      </div>
    );
  });

  // Loading durumunda loading ekranı göster
  if (loading) {
    return (
      <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#fff]">
        <div className="flex flex-col items-center justify-center">
          <div className="relative mb-8">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60"
                style={{
                  animationDirection: "reverse",
                  animationDuration: "1.5s",
                }}
              ></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800 animate-pulse">
            Yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen min-h-screen flex flex-col items-center bg-[#F8F9FB] overflow-hidden">
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        profileData={profileData}
      />
      <div className="flex flex-col items-center w-full h-full sm:max-w-[390px] bg-white sm:rounded-[40px] shadow-2xl relative overflow-y-auto no-scrollbar">
        {/* Modern Header Section - Streamlined & Minimalist */}
        <div className="w-full relative h-[140px] flex-shrink-0">
          <div className="absolute inset-0 z-0">
            <img
              src="/assets/pngImages/welcomeScreen.png"
              className="w-full h-full object-cover"
              alt="Welcome"
            />
            <div className="absolute inset-0 bg-black/5"></div>
            <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-white via-transparent to-transparent"></div>
          </div>

          {/* Top Bar - Center-aligned for a balanced minimalist look */}
          <div className="relative z-10 px-6 pt-10 flex items-center justify-between">
            <div
              onClick={() => setIsSidebarOpen(true)}
              className="flex items-center gap-2 backdrop-blur-md bg-white/10 p-1.5 px-3 rounded-xl border border-white/20 cursor-pointer hover:bg-white/20 transition-all active:scale-95"
            >
              <img
                src="/assets/pngImages/jodiacLogoML.png"
                alt="JODIAC Logo"
                className="w-20 h-auto object-contain"
              />
            </div>
            <div className="flex items-center gap-2">
              <div
                onClick={() => navigate(`/${id}/settings`)}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-md p-1 pr-3 rounded-full border border-white/20 cursor-pointer hover:bg-white/20 transition-all"
              >
                {profileData?.pictureDetails?.pictureUrl ? (
                  <img
                    src={profileData.pictureDetails.pictureUrl}
                    alt="Profile"
                    className="w-7 h-7 rounded-full border border-[#3DA7B5] shadow-md"
                  />
                ) : (
                  <div className="w-7 h-7 rounded-full bg-[#3DA7B5] flex items-center justify-center text-white font-bold text-[10px]">
                    {profileData?.first_name?.charAt(0)}
                  </div>
                )}
                <span className="text-white text-[10px] font-bold uppercase tracking-wider">
                  {profileData?.first_name}
                </span>
              </div>

              <button
                onClick={() => navigate(`/${id}/store`)}
                className="w-9 h-9 flex items-center justify-center bg-white/10 backdrop-blur-md rounded-full border border-white/20 text-white hover:bg-white/20 transition-all active:scale-90"
              >
                <FiShoppingBag size={18} />
              </button>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-full pt-0 bg-white relative z-20 -mt-6 rounded-t-[40px] shadow-[0_-20px_40px_rgba(0,0,0,0.05)]">
          {/* Tab Switcher Modern */}
          <div className="w-full px-6 mt-6 mb-4">
            <div className="bg-gray-100/80 p-1.5 rounded-3xl flex items-center relative gap-1">
              {["Bana Özel", "Bize Özel", "Astrologlar"].map((label) => {
                const isActive = activeCategory === label;
                return (
                  <button
                    key={label}
                    onClick={() => setActiveCategory(label)}
                    className={`relative flex-1 py-2.5 rounded-2xl text-xs font-black transition-all duration-500 ${isActive ? "text-white" : "text-gray-500"
                      }`}
                  >
                    {isActive && (
                      <motion.div
                        layoutId="activeTab"
                        className="absolute inset-0 bg-[#3DA7B5] rounded-2xl shadow-lg shadow-[#3DA7B5]/30"
                        transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                      />
                    )}
                    <span className="relative z-10">{label}</span>
                  </button>
                );
              })}
            </div>
          </div>
          <div className="w-full px-6 pb-40">
            <ResponsiveMasonry
              columnsCountBreakPoints={{ 350: 2, 750: 2 }}
              className="w-full"
            >
              <Masonry columnsCount={2} gutter="12px">
                {activeCategory === "Astrologlar" ? astrologerCards : moduleCards}
              </Masonry>
            </ResponsiveMasonry>
          </div>
        </div>
      </div>
    </div>
  );
}
